import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";
import acc from 'accounting'
import * as html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
import logo from '../../../../resources/images/logo/marcelbus.png'

export default class UrzadRaportDoplatSumTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            trybDruku: false,

            wszystkieKolumnyEksport: [
                {value: "nazwa", label: 'Nazwa'},
                {value: "proculgi", label: '% ulgi'},
                {value: "lbil", label: 'Liczba biletów'},
                {value: "doplbrutto", label: 'Dopłata brutto'},
                {value: "doplnetto", label: 'Dopłata netto'},
                {value: "doplvat", label: 'Dopłata VAT'},
            ],
            kolumnyDoExportuDefault: [
                {value: "nazwa", label: 'Nazwa'},
                {value: "proculgi", label: '% ulgi'},
                {value: "lbil", label: 'Liczba biletów'},
                {value: "doplbrutto", label: 'Dopłata brutto'},
                {value: "doplnetto", label: 'Dopłata netto'},
                {value: "doplvat", label: 'Dopłata VAT'},
            ],
        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops) {
    }

    drukujRaport = () => {

        this.setState({trybDruku: true})

        //  alert('test druk')

        /*html2canvas(document.getElementById('wydruk-raport'))
            .then((canvas) => {
                let image = canvas.toDataURL("image/jpeg");
                let doc = new jsPDF();
                doc.addImage(image, 'JPEG', 10, 10, canvas.width * 0.115, canvas.height * 0.115, "a", "FAST");
                   doc.autoPrint();
                // window.open(doc.output('bloburl'));
                doc.output('dataurlnewwindow');
            })*/


        const printArea = document.getElementById("printWrapper");

        html2canvas(printArea)
            .then(canvas => {
                const dataURL = canvas.toDataURL();
                const pdf = new jsPDF();

                pdf.addImage(dataURL, 'JPEG', 10, 10, canvas.width * 0.11, canvas.height * 0.11);

                let data = '';

                data = new Date().toJSON().substr(0, 16)


                pdf.save('raport-marcel-bus' + data + '.pdf')
                this.setState({trybDruku: false})
            })
            .catch(err => {
                this.setState({trybDruku: false})
            })

    }


    formatCenaCell(cell, row) {

        if (row.nazwa.indexOf("Suma dopłat ogółem") > -1) {
            return <div style={{fontWeight: "bold", fontSize: '18px', textAlign: "right"}}>{acc.formatMoney(cell)}</div>
        }
        else if (row.nazwa.indexOf("Suma dopłat do biletów") > -1) {
            return <div style={{fontWeight: "bold", textAlign: "right"}}>{acc.formatMoney(cell)}</div>
        }
        else {
            return <div style={{textAlign: "right"}}>{acc.formatMoney(cell)}</div>
        }
    }


    formatCell(cell, row) {

        if (row.nazwa.indexOf("Suma dopłat ogółem") > -1) {
            return <div style={{fontWeight: "bold", fontSize: '18px'}}>{cell}</div>
        }
        else if (row.nazwa.indexOf("Suma dopłat do biletów") > -1) {
            return <div style={{fontWeight: "bold"}}>{cell}</div>
        }
        else {
            return <div>{cell}</div>
        }
    }

    render() {
        const options = {
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div style={{padding: "15px 0", marginTop: "10px"}} id={'printWrapper'}>
                {
                    this.state.trybDruku && <div style={{textAlign: 'center'}}><img style={{maxHeight: '50px'}} src={logo} alt={'logo'}/></div>

                }
                <h3 style={{textAlign: "center", marginTop: 0, marginBottom: 0}}>
                    Zestawienie dopłat do biletów ulgowych za okres {this.props.dataOd} - {this.props.dataDo}
                </h3>
                {
                    !this.state.trybDruku &&
                    <div>
                        <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                      kolumnyDoExportu={this.state.kolumnyDoExportuDefault}
                                      czyPokazacDoDruku={true}
                                      onClickPrint={() => this.drukujRaport()}
                        />

                    </div>
                }
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='nazwa' isKey
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                           dataFormat={this.formatCell}
                        >Nazwa ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='proculgi'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.formatCell}
                        >% ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='lbil'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.formatCell}
                        >Ilość biletów</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplnetto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Dopłata netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplvat'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Dopłata VAT</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplbrutto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Dopłata brutto</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raportDopatSuma/components/UrzadRaportDoplatSumTable.js